import { useRef, useState } from 'react'
import type { SearchState, UnitType } from '@/types/search'

export const useSearchState = () => {
  // Search states
  const [productName, setProductName] = useState('')
  const [sectionModulus, setSectionModulus] = useState('')
  const [sectionModulusUnit, setSectionModulusUnit] = useState<UnitType>('metric')
  const [bendingMoment, setBendingMoment] = useState('')
  const [bendingMomentUnit, setBendingMomentUnit] = useState<UnitType>('metric')
  const [selectedSteelGrade, setSelectedSteelGrade] = useState<number | undefined>(3)
  const [showSuggestions, setShowSuggestions] = useState(false)
  const [showModulusSuggestions, setShowModulusSuggestions] = useState(false)
  const [showBendingSuggestions, setShowBendingSuggestions] = useState(false)
  const [selectedIndex, setSelectedIndex] = useState(-1)
  const [searchError, setSearchError] = useState('')

  // Refs for click outside detection
  const searchContainerRef = useRef<HTMLDivElement | null>(null)
  const modulusSearchRef = useRef<HTMLDivElement | null>(null)
  const bendingSearchRef = useRef<HTMLDivElement | null>(null)

  const searchState: SearchState = {
    productName,
    sectionModulus,
    sectionModulusUnit,
    bendingMoment,
    bendingMomentUnit,
    selectedSteelGrade,
    showSuggestions,
    showModulusSuggestions,
    showBendingSuggestions,
    selectedIndex,
    searchError,
  }

  return {
    searchState,
    setters: {
      setProductName,
      setSectionModulus,
      setSectionModulusUnit,
      setBendingMoment,
      setBendingMomentUnit,
      setSelectedSteelGrade,
      setShowSuggestions,
      setShowModulusSuggestions,
      setShowBendingSuggestions,
      setSelectedIndex,
      setSearchError,
    },
    refs: {
      searchContainerRef,
      modulusSearchRef,
      bendingSearchRef,
    },
  }
}
